import { map, set } from 'lodash/fp';

import { ResourceStateReasonClassification } from '@mews-commander/resources';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction, notEmpty } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import prefix from '../prefix';
import { setResourceCategories } from '../ducks/resourceCategories';
import { setResourceCategoryAssignments } from '../ducks/resourceCategoryAssignments';
import { setResourceFeatureAssignments } from '../ducks/resourceFeatureAssignments';
import { setResourceFeatures } from '../ducks/resourceFeatures';
import { setResources, getResourcesChildrenIds } from '../ducks/resources';
import { setResourceSlots } from '../ducks/resourceSlots';
import { getEnterpriseProfileId } from '../ducks/scopes';
import { dispatchScopedGroupedEntityActions } from '../ducks/utils';

const RESOURCE_EXTENT = {
    Slots: false,
    Resources: true,
    ResourceFeatures: true,
    ResourceCategories: true,
    ResourceCategoryAssignments: true,
    ResourceFeatureAssignments: true,
};

const RESOURCES_UPDATE = prefix('RESOURCES_UPDATE');
const RESOURCES_FETCH = prefix('RESOURCES_FETCH');

export const fetchResources =
    ({ enterpriseId, extent = RESOURCE_EXTENT }: $TSFixMe = {}) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const state = getState();
        const selectedEnterpriseId = enterpriseId ?? getCurrentEnterpriseId();
        const profileId = getEnterpriseProfileId(state, { enterpriseId: selectedEnterpriseId });
        const promise = container()
            .resourceComponent.getAll({
                profileId,
                enterpriseId: selectedEnterpriseId,
                extent,
            })
            .then((data: $TSFixMe) => {
                const {
                    resources,
                    resourceCategories,
                    resourceFeatures,
                    resourceCategoryAssignments,
                    resourceFeatureAssignments,
                    slots,
                } = data;
                if (notEmpty(resources)) {
                    dispatch(setResources(resources, selectedEnterpriseId));
                }
                if (notEmpty(resourceCategories)) {
                    dispatch(
                        dispatchScopedGroupedEntityActions({
                            entities: resourceCategories,
                            action: setResourceCategories,
                            scopeName: 'serviceId',
                        })
                    );
                }
                if (notEmpty(resourceFeatures)) {
                    dispatch(setResourceFeatures(resourceFeatures));
                }
                if (notEmpty(resourceCategoryAssignments)) {
                    const resourceCategoryAssignmentsWithIds = map((i) =>
                        // @ts-expect-error $TSFixMeError: No overload matches this call.
                        set('id', `${(i as $TSFixMe).resourceId}-${(i as $TSFixMe).categoryId}`, i)
                    )(resourceCategoryAssignments);
                    // @ts-expect-error $TSFixMeError: Argument of type 'LodashSet1x4<object>[]' is not assignable to parameter of type 'ResourceCategoryAssignments[]'.
                    dispatch(setResourceCategoryAssignments(resourceCategoryAssignmentsWithIds));
                }
                if (notEmpty(slots)) {
                    dispatch(setResourceSlots(slots));
                }
                if (notEmpty(resourceFeatureAssignments)) {
                    dispatch(setResourceFeatureAssignments(resourceFeatureAssignments));
                }
                return data;
            });

        return dispatch(createFetchAction(RESOURCES_FETCH, promise));
    };

export const updateResources =
    ({ resourceUpdates }: $TSFixMe): CommanderThunkAction<AsyncAction<void>> =>
    async (dispatch, getState, { container }) => {
        const enterpriseId = getCurrentEnterpriseId();
        const promise: Promise<void> = container()
            .resourceComponent.update({ enterpriseId, resourceUpdates })
            .then(({ resources }: $TSFixMe) => {
                if (notEmpty(resources)) {
                    dispatch(setResources(resources, enterpriseId));
                }
            });

        return dispatch(createFetchAction(RESOURCES_UPDATE, promise));
    };

export const updateResourcesState =
    ({
        resourceIds,
        state,
        stateReason,
        stateReasonClassification = ResourceStateReasonClassification.Other,
    }: $TSFixMe): CommanderThunkAction<Promise<unknown>> =>
    async (dispatch, getState) => {
        const enterpriseId = getCurrentEnterpriseId();
        const childrenIds = getResourcesChildrenIds(getState(), { resourceIds, enterpriseId });
        const allResourceIds = [...resourceIds, ...childrenIds];

        const resourceUpdates = map(
            (resourceId) => ({
                resourceId,
                state: {
                    value: state,
                },
                stateReason: {
                    value: stateReason,
                },
                stateReasonClassification: { value: stateReasonClassification },
            }),
            allResourceIds
        );

        return dispatch(updateResources({ resourceUpdates }));
    };
